import { gql } from '@apollo/client'

export const RECRUITER_ACCOUNTS_QUERY = gql`
	query recruiterAccountsQuery($filter: AccountFilter!) {
		recruiterAccounts(filter: $filter) {
			value: id
			label: name
		}
	}
`
